import React from "react";
import { InlineTimePicker, InlineDatePicker, InlineDateTimePicker,MuiPickersUtilsProvider} from 'material-ui-pickers';
import DateFnsUtils from "@date-io/date-fns";
import { isValid as isDateTimeValid, parse, format } from "date-fns";
import { withStyles} from "@material-ui/core/styles";
import DateRange from '@material-ui/icons/DateRange';
import ArrowLeft from '@material-ui/icons/ChevronLeft';
import ArrowRight from '@material-ui/icons/ChevronRight';
import Time from '@material-ui/icons/AccessTime';
import Clear from '@material-ui/icons/CancelOutlined';
import InputAdornment from '@material-ui/core/InputAdornment';
import appConstants from "./../../../../appConstants";

const styles = theme => ({
    dateTimeContainer:{
        maxWidth: 160,
        backgroundColor: "transparent",
        marginTop:6,
        '& $inputRoot $inputStyle$textInput':{
            fontSize: theme.textFontSize,
            color:theme.TextColor,
            padding: 5,
            height: 24,
            border:0,
            '&:focus':{
                padding:5,
                border:0,
            },
            '&::placeholder':{
                color:"inherit"
            }
        }
    },
    paperStyle:{
        backgroundColor: theme.ModalBGColor,
        color:theme.TextColor
    },
    labelProps:{
        fontSize: theme.textFontSize,
        color:theme.TextColor,
        opacity: 0.4
    },
    inputStyle:{
        fontSize: theme.textFontSize,
        color:theme.TextColor,
        padding: 5,
        height: 24,
        border:0,
        '&:focus':{
            padding:5,
            border:0,
        }
    },
    textInput:{
    },
    inputRoot:{
        fontSize: theme.textFontSize,
        color:theme.TextColor,
        backgroundColor:  theme.ComponentHeader,
        outline: "none",
        height: 24,
        border: `1px solid ${theme.iconColor}`,
        boxSizing: "border-box",
        '&::before, &::after':{
            border: "none !important"
        },
        '&$disabledInput':{
            backgroundColor: theme.disabledTextBG
        }
    },
    iconColor:{
        color: theme.iconColor,
    },
    inputAdornment:{
        cursor: "pointer",
    },
    iconStyle:{
        color: theme.iconColor,
        cursor: "pointer",
        paddingRight: 4
    },
    dateTimeWidth:{
        maxWidth: 130
    },
    dateWidth:{
        maxWidth: 130
    },
    timeWidth:{
        maxWidth: 100
    },
    helperText:{
        margin:0,
        paddingTop:4,
        fontSize:11,
        backgroundColor: theme.ComponentHeader,
    },
    disabledInput:{
       
    }
})


class DateTimeComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dateTimeValue : null
        }
        this.iconProps = {};
        this.picker = null;
        this.dateType = {};
        this.KeyboardIcon = DateRange;
        this.PickerComponent = InlineDateTimePicker;
        this.inputWidthClass = this.props.classes.dateTimeWidth;
        this.currentDate = new Date();

    }

    componentDidMount(){
        this.updateDateTime();
    }

    componentDidUpdate(prevProps){
        // Update the editor when field changes in bulk edit
        if((this.props.column && prevProps.column.colDef.field != this.props.column.colDef.field) || this.props.value !== prevProps.value){
            this.updateDateTime();
        }
    }

    updateDateTime = () => {
        const { DATETYPES } = appConstants;
        this.dateType = this.props.dateType || this.props.column.colDef.cellEditorParams.DATETYPE || appConstants.DATETYPES.DATETIME;

        let dateTimeValue = this.props.value;
        const { colDef } = this.props.column || {};
        dateTimeValue = colDef && colDef.valueFormatter ? colDef.valueFormatter({value: dateTimeValue}) : dateTimeValue;
        if(dateTimeValue){
           dateTimeValue = parse(dateTimeValue, this.dateType.format, new Date())
        }
        if(this.dateType.type === DATETYPES.TIME.type){
            this.iconProps = { ampm: false};
            this.KeyboardIcon = Time;
            this.PickerComponent = InlineTimePicker;
            this.inputWidthClass = this.props.classes.timeWidth;
        }else if(this.dateType.type === DATETYPES.DATE.type){
            this.iconProps = {
                leftArrowIcon:<ArrowLeft/>,
                rightArrowIcon:<ArrowRight/>
            }
            this.KeyboardIcon = DateRange;
            this.PickerComponent = InlineDatePicker;
            this.inputWidthClass = this.props.classes.dateWidth;
        }else {
            this.iconProps = {
                leftArrowIcon:<ArrowLeft/>,
                rightArrowIcon:<ArrowRight/>,
                ampm: false,
                dateRangeIcon:<DateRange/>,
                timeIcon:<Time/>
            }
            this.KeyboardIcon = DateRange;
            this.PickerComponent = InlineDateTimePicker;
            this.inputWidthClass = this.props.classes.dateTimeWidth;
        }
        this.onChange(dateTimeValue);
    }

    onChange = (value) => {
        if(typeof value === 'string' && value ){
            value = new Date(value)
        }
        this.setState({
            dateTimeValue: value ? value : null
        }, this.updateParent)
    }

    clear = () => {
      if(!this.props.disabled){
        this.onChange(null);
      }
    }

    onInputChange = event => {
        // On keyboard input, update the datetime value when valid value is added
        // updating invalid value to datetime will not allow you to edit again
        const updatedDateTime = parse(event.target.value,this.dateType.format, new Date());
        if(isDateTimeValid(updatedDateTime)){
            this.onChange(updatedDateTime);
        } else if(this.props.onChange){
            this.props.onChange(updatedDateTime);
        }
    }

    updateParent = () => {
        if(this.props.onChange){
            let dateTime = null;
            if(this.state.dateTimeValue && isDateTimeValid(this.state.dateTimeValue)){
                dateTime = format(this.state.dateTimeValue, this.dateType.updateFormat);
            }
            this.props.onChange(dateTime);
        }
    }

    openPicker = (event) => {
        if(!this.props.disabled){
            this.picker.open(event);
        }
    }

    render(){
        const { classes, disableFocusInput, label} = this.props;
        const { PickerComponent, KeyboardIcon} = this;
        const disablePickerPortal = !Boolean(this.props.enablePickerPortal)
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <div className={classes.dateTimeContainer}>
                    <PickerComponent
                        keyboard
                        clearable
                        disableOpenOnEnter
                        format={this.dateType.format}
                        placeholder={this.dateType.placeholder}
                        {...this.iconProps}
                        value={this.state.dateTimeValue}
                        onChange={this.onChange}
                        mask={this.dateType.inputMask}
                        ref={node=> this.picker = node}
                        FormHelperTextProps={{
                            classes:{
                                root: classes.helperText
                            }
                        }}
                        PopoverProps={{
                            disablePortal: disablePickerPortal,
                        }}
                        InputLabelProps={this.props.InputLabelProps ?? {
                            classes:{
                                root: classes.labelProps
                            }
                        }}
                        InputProps={{
                            autoFocus: disableFocusInput ? false : true,
                            endAdornment: (<InputAdornment position="end" classes={{root: classes.inputAdornment}}>
                                                { this.state.dateTimeValue ? <Clear classes={{root: classes.iconStyle}} onClick={this.clear}/> : null}
                                                <KeyboardIcon  classes={{root: classes.iconStyle}} onClick={this.openPicker} />
                                                </InputAdornment>),                  
                            classes:{
                                root:`dateTimeContainer ${classes.inputRoot} ${this.inputWidthClass} ${this.props.inputRootClass ?? ""}`,
                                input: `${classes.inputStyle} ${classes.textInput}`,
                                disabled: classes.disabledInput,
                                focused : this.props.inputFocusedClass
                            },
                            inputRef: this.props.inputRef
                        }}
                        // classes={{
                        //     popoverPaper: classes.paperStyle,
                        // }}
                        disabled={this.props.disabled ?? false}
                        onInputChange={this.onInputChange}
                        disableFuture={this.props.disableFuture || false}
                        shouldDisableDate={this.props?.shouldDisableDate}
                        invalidDateMessage= {`Invalid ${this.dateType.type}`}
                        onKeyDown={this.props?.onKeyDown}
                        minDate={this.props.minDate}
                        maxDate = {this.props.maxDate}
                        label={label}
                        variant={this.props.variant}
                        renderDay = {this.props.renderDay}
                        minDateMessage={this.props.minDateMessage}
                    />
                </div>
         </MuiPickersUtilsProvider>
        )
    }
}
export default withStyles(styles)(DateTimeComponent);